import { createPopper } from './popper'
/**
 * Class Manage Menu
 */
 export default class Menu {
  constructor () {
    this.elementsNav = '#js-header-nav .header__menu-item'
    this.linkAttribe = 'data-top-menu'
    this.offset = [0, 10]
    this.mediaQuery = '(max-width: 992px)' // big tablet
    this.mediaQueryList = window.matchMedia(this.mediaQuery)
    this.isMobile = this.mediaQueryList.matches
    this.menuItemActive = null

    // Media query observer
    try {
      this.mediaQueryList.addEventListener('change', event => {
          this.mediaChange(event)
      })
    } catch (er) {
      // if not supported change (old version safari ios)
      try {
        this.mediaQueryList.addEventListener(event => {
          this.mediaChange(event)
        })
      } catch (er2) {
        console.error('Menu => error', er2)
      }
    }

    this.initMenu()
    this.initOpenBtn()
    this.initCloseBtn()
  }

  /**
   *  check if mobile version
   * @param {Event} event
   */
  mediaChange (event) {
    if (event.matches) {
      this.isMobile = true
    } else {
      this.isMobile = false
      if (this.menuItemActive) this.hideMenu(this.menuItemActive)
    }
  }

  /**
   * initialization of menu events
   */
  initMenu () {
    document.querySelectorAll(this.elementsNav).forEach((item) => {
      const link = item.querySelector('a[' + this.linkAttribe + ']')

      if (link) {
        const submenu = link.nextElementSibling
        const popperInstance = createPopper(link, submenu, {
          placement: 'bottom',
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: this.offset
              }
            }
          ]
        })
        item.addEventListener('mouseenter', (e) => {
          if (!this.isMobile) this.showMenu(e.currentTarget, popperInstance)
        })
        item.addEventListener('mouseleave', (e) => {
          if (!this.isMobile) this.hideMenu(e.currentTarget)
        })

        item.addEventListener('click', (e) => {
          if (this.isMobile) {
            if (e.target.hasAttribute(this.linkAttribe)) {
              // e.preventDefault()
              this.toggleMenu(e.currentTarget, popperInstance)
            }
          }
        })
      }
    })
  }

  /**
 * event Btn Open menu
 */
  initOpenBtn () {
    // Open Menu
    const btnHamburger = document.querySelector('#js-hamburger-btn')
    btnHamburger.addEventListener('click', (e) => {
      e.preventDefault()
      this.navMenu = document.querySelector(e.target.getAttribute('data-target'))
      // console.log(navMenu, e.target.getAttribute('data-target'))
      if (this.navMenu) {
        this.navMenu.classList.add('is-open')
      }
    })
  }

  /**
 * event Btn close menu
 */
  initCloseBtn () {
    // Close Menu
    const closeBtn = document.querySelector('[data-event]')
    const type = closeBtn.getAttribute('data-event')
    if (type === 'close') {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault()
        if (this.navMenu) {
          this.navMenu.classList.remove('is-open')
        }
      })
    }
  }

  /**
   * Show item menu
   * @param {HTMLElement} target
   * @param {popperInstance} popperInstance
   */
  showMenu (target, popperInstance) {
    const element = target.querySelector('a[' + this.linkAttribe + ']')
    if (element !== null) {
      const subMenu = element.nextElementSibling
      if (subMenu !== null) {
        element.classList.add('show')
        element.setAttribute('aria-expanded', true)
        subMenu.classList.add('show')
        popperInstance.update()
      }
    }
  }

  /**
   * * Hide item menu
   * @param {HTMLElement} target
   */
  hideMenu (target) {
    const element = target.querySelector('a[' + this.linkAttribe + ']')
    if (element !== null) {
      const subMenu = element.nextElementSibling
      if (subMenu !== null) {
        element.setAttribute('aria-expanded', false)
        element.classList.remove('show')
        subMenu.classList.remove('show')
      }
    }
  }

  /**
   * Toogle item menu
   * @param {HTMLElement} target
   * @param {popperInstance} popperInstance
   */
  toggleMenu (target, popperInstance) {
    if (this.menuItemActive) {
      this.hideMenu(this.menuItemActive)
    }
    if (this.menuItemActive !== target) {
      this.showMenu(target, popperInstance)
      this.menuItemActive = target
    } else {
      this.menuItemActive = null
    }
  }
}
